import { render } from "./SubmittalCounterSummaryCard.vue?vue&type=template&id=6435f522&scoped=true"
import script from "./SubmittalCounterSummaryCard.vue?vue&type=script&lang=js"
export * from "./SubmittalCounterSummaryCard.vue?vue&type=script&lang=js"

import "./SubmittalCounterSummaryCard.vue?vue&type=style&index=0&id=6435f522&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6435f522"]])

export default __exports__